import get from 'lodash/get';

export const getSettings = state => state.talk.settings;
export const getServerOnline = state => get(state, `talk.settings.serverOnline`, false);
